import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Chip element, used for each individual chip within the Chipbar element
 *
 * @prop {String} label - mandatory, used to define the chip text
 * @prop {String} color - optional, used to set a custom background color
 * @prop {String} icon - optional, used to set a icon at the start of the chip
 * @prop {Boolean} primary - optional, displays the chip with a themecolor background, used for activated tags
 * @prop {Boolean} filter - optional, displays the chip with a button color, used to display activated filters
 * @prop {Boolean} light - optional, displays the chip text in the theme ligt color
 *
 */
let SDBChip = class SDBChip extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.color = '';
        this.icon = '';
        this.primary = false;
        this.filter = false;
        this.light = false;
        this.warning = false;
    }
    render() {
        return html `
            <div style="background:${this.color}">
                ${this.icon
            ? html `<sdb-content-icon
                          class="icon"
                          size="16"
                          icon="${this.icon}"
                      ></sdb-content-icon>`
            : html ``}
                ${this.label}
                ${this.filter
            ? html `<sdb-content-icon
                          class="filter"
                          size="16"
                          icon="fal fa-circle-xmark"
                      ></sdb-content-icon>`
            : html ``}
            </div>
        `;
    }
};
SDBChip.styles = [
    elements,
    css `
            :host div {
                display: flex;
                justify-content: center;
                width: auto;
                height: 12px;
                padding: 0 10px;
                margin: 5px 5px 5px 0;
                height: 24px;
                line-height: 22px;
                font-size: 14px;
                background: rgba(0, 0, 0, 0.065);
                color: var(--text-primary);
                border-radius: 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            :host([primary]) div {
                background: var(--theme-primary);
                color: var(--theme-primary-text);
            }

            :host([light]) div {
                color: var(--text-light);
            }

            :host([filter]) div {
                background: var(--btn-primary);
                color: var(--btn-primary-text);
                padding-right: 5px;
            }

            :host([warning]) div {
                background: var(--chip-warning-background-color);
            }

            :host sdb-content-icon.icon {
                display: inline-flex;
                align-self: center;
                margin-right: 5px;
            }

            :host sdb-content-icon.filter {
                display: inline-flex;
                align-self: center;
                margin-left: 5px;
                cursor: pointer;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBChip.prototype, "label", void 0);
__decorate([
    property({ type: String })
], SDBChip.prototype, "color", void 0);
__decorate([
    property({ type: String })
], SDBChip.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBChip.prototype, "primary", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBChip.prototype, "filter", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBChip.prototype, "light", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBChip.prototype, "warning", void 0);
SDBChip = __decorate([
    customElement('sdb-content-chip')
], SDBChip);
export { SDBChip };
//# sourceMappingURL=sdb-content-chip.js.map